import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { googleAnalyticsHeadScripts } from '../../../assets/scripts/gtm';

export interface AppConfigurationItem
{
  baseUrl: string;
}

export interface GoogleConfigurationItem
{
  gtmId: string;
  mapBaseUrl: string;
}

export interface AppConfiguration
{
  environmentKey: string;
  cacheTokenToLocalStorage: boolean;
  api: AppConfigurationItem;
  community: AppConfigurationItem;
  ws: AppConfigurationItem;
  clinicalViewer: AppConfigurationItem;
  flowable: AppConfigurationItem;
  pageSize: number;
  /** Messages per page when loading chat history (scroll up for older). Defaults to 50 in UI when omitted. */
  chatHistoryPageSize?: number;
  chatRecentEmojisLimit?: number;
  google: GoogleConfigurationItem;
}

@Injectable({
  providedIn: 'root'
})
export class AppConfigService
{
  private appConfig: AppConfiguration;

  /**
   * Load application configuration from json file.
   */
  public loadAppConfig(): any
  {
    return new Promise((resolve, reject) =>
    {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', environment.apiUrl);

      xhr.addEventListener('readystatechange', () =>
      {
        if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200)
        {
          this.appConfig = JSON.parse(xhr.responseText);

          // Initializing Google Tag Manager based on gtmId
          googleAnalyticsHeadScripts(this.appConfig);

          resolve(this.appConfig);
        }
        else if (xhr.readyState === XMLHttpRequest.DONE)
        {
          reject();
        }
      });
      xhr.send(null);
    });
  }

  public getConfig(): AppConfiguration
  {
    return this.appConfig;
  }
}
